import { formatBRL } from '@lira/shared';
import { usePrivacyStore } from '@/stores/privacy';
import { cn } from '@/lib/cn';

interface MoneyTextProps {
  /** Valor em centavos inteiros. */
  cents: number;
  /** true => verde se >=0, vermelho se <0. false (default) => text-ink neutro. */
  colorBySign?: boolean;
  /** Exibe "+" em valores positivos para não depender apenas da cor. */
  showPositiveSign?: boolean;
  bold?: boolean;
  className?: string;
}

/**
 * Fonte ÚNICA de exibição de dinheiro no app: formata em BRL, colore por sinal
 * (opcional) e respeita o "ocultar valores" (usePrivacyStore).
 */
export function MoneyText({ cents, colorBySign = false, showPositiveSign = false, bold = false, className }: MoneyTextProps) {
  const hidden = usePrivacyStore((s) => s.hidden);

  const color = colorBySign ? (cents < 0 ? 'text-expense' : 'text-income') : 'text-ink';

  return (
    <span
      className={cn('tabular-nums', color, bold && 'font-bold', className)}
      aria-label={hidden ? 'Valor oculto' : undefined}
    >
      {hidden ? '••••••' : `${showPositiveSign && cents > 0 ? '+' : ''}${formatBRL(cents)}`}
    </span>
  );
}
